// browserRegex is auto-generated regex based on supported browsers list in .browserslistrc
import { browsersRegex } from "virtual:supported-browsers";

export class BrowserHelper {
  public static isSupportedBrowser() {
    return browsersRegex.test(navigator.userAgent);
  }
}
